import React from 'react';
import Table from 'react-bootstrap/Table';
import { Link } from 'react-router-dom';
import trash_icon from '../../assets/images/icons/user-dashboard/trash-icon.png';
import CustomModalView from '../../common/input/customModal/customModalView';
import { Navigate } from 'react-router-dom';




const CvPageView = (props) => {
// if (localStorage.getItem("token") != null) {
        return (
           <>
                 <div className="registration-form_main">
            <div className="registration-form_wrapper">

                <form id="individual-personal-details_form">
                    <div className="form-group">
                        <label htmlFor="exampleInputEmail1">Email Address<sup>*</sup></label>
                        <input  type="email" value={props.email} onChange={(e) => props.handelData('email', e.target.value)} className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Your Email Address here" />
                        <div className="form-error-msg">{props.setemail_validate}</div>
                    </div>
                     <div className="form-group">
                        <label>Job Title<sup>*</sup></label>
                        <select value={props.jobtitle} onChange={(e) => props.handelData('jobtitle', e.target.value)} id="inputapply" className="form-control">
                            <option>Applying As</option>
                            {props.title_type.map((title_type, index) => (
                                <option value={title_type.id}>{title_type.type}</option>
                            ))}
                        </select>
                     <div className="form-error-msg">{props.setjob_validate}</div>
                    </div>

                     <div className="form-group">
                        <label>Title<sup>*</sup></label>
                        <select  value={props.title} onChange={(e) => props.handelData('title', e.target.value)} id="inputapply" className="form-control">
                            <option>Title</option>
                            <option value="Mr">Mr</option>
                            <option value="Mrs">Mrs</option>
                            <option  value="Miss">Miss</option>
                            <option  value="Ms">Ms</option>

                        </select>
                        
                    </div>


                    <div className="form-group">
                        <label>First Name<sup>*</sup></label>
                        <input type="text" value={props.firstname} onChange={(e) => props.handelData('firstname', e.target.value)} className="form-control" placeholder="Your First Name here" />
                        <div className="form-error-msg">{props.setfirstname_validate}</div>
                    </div>
                    <div className="form-group">
                        <label>Last Name<sup>*</sup></label>
                        <input type="text" value={props.lastname} onChange={(e) => props.handelData('lastname', e.target.value)} className="form-control" placeholder="Your Last Name here" />
                        <div className="form-error-msg">{props.setlastname_validate}</div>
                    </div>
                    <div className="form-group">
                        <label>Date of Birth<sup>*</sup></label>
                        <div className="form-row">
                            <div className="col">
                                <select value={props.date} id="inputDate"  onChange={(e) => props.handelData('date', e.target.value)} className="form-control">
                                        <option  >Date</option>
                                     {props.date_list.map((date, index) => (
                                        <option value={date}>{date}</option>
                                    ))}
                                </select>
                                <div className="form-error-msg">{props.setdate_validate}</div>
                            </div>
                            <div className="col">
                                <select value={props.month} id="inputMonth" onChange={(e) => props.handelData('month', e.target.value)} className="form-control">
                                    <option >Month</option>
                                     {props.months_list.map((month, index) => (
                                        <option value={month.number}>{month.text}</option>
                                    ))}
                                </select>
                                <div className="form-error-msg">{props.setmonth_validate}</div>
                            </div>
                            <div className="col">
                                <select value={props.year} id="inputYear" onChange={(e) => props.handelData('year', e.target.value)} className="form-control">
                                    <option >Year</option>
                                    {props.years.map((year, index) => (
                                        <option value={year}>{year}</option>
                                    ))}
                                </select>
                                <div className="form-error-msg">{props.setyear_validate}</div>
                            </div>
                        </div>
                    </div>
                    <div className="form-group">
                        <label>Enter the Post Code, Select Search Button<sup>*</sup></label>
                        <div className="form-row">
                            <div className=" col-sm-9 mb-10">
                                <input value={props.zipcode} onChange={(e) => props.handelData('zipcode', e.target.value)} type="text" className="form-control" placeholder="WC2N 5DU" />
                            </div>
                            <button type="button" onClick={() => props.getDataPostCode()} className="btn btn-primary btn-sm mt-n3 col-sm-3">search</button>


                        </div>
                        <div className="form-error-msg">{props.setzipcode_validate}</div>
                    </div>
                    
                    <div className="form-group">
                        <label>Select Address From The List After Entering Post Code<sup>*</sup></label>
                          <select value={props.address} onChange={(e) => e.target.value && props.handelData('address', e.target.value)} className="form-control">
                                    {(props.address_list && props.address_list.length > 0) ? <option value="" >Select the Addresss</option> : <option value="">Enter Postcode</option>}
                                    {props.address_list && props.address_list.map((each, index) => (
                                        each && <option value={each}>{each}</option>
                                    ))}
                                </select>
                    </div>
                    {/*
                    <div className="form-group">
                        <label>Address Line 2 (Optional)</label>
                        <input type="text" onChange={(e) => props.handelData('address1', e.target.value)} className="form-control" placeholder="Your Address here" />

                    </div>
                    
                     <div className="form-group">
                        <label>Country <sup>*</sup></label>
                        <div className="form-row">
                            <div className="col">
                                <input value={props.country} type="text" onChange={(e) => props.handelData('country', e.target.value)} className="form-control" placeholder="Country" />
                            </div>
                        </div>
                        <div className="form-error-msg">{props.setcountry_validate}</div>
                    </div>
                    <div className="form-group">
                        <label>City <sup>*</sup></label>
                        <div className="form-row">
                            <div className="col">
                                   <input value={props.city} type="text" onChange={(e) => props.handelData('city', e.target.value)} className="form-control" placeholder="City" />
                            </div>
                        </div>
                        <div className="form-error-msg">{props.setcity_validate}</div>
                    </div>
                    <div className="form-group">
                        <label>County <sup>*</sup></label>
                        <div className="form-row">
                            <div className="col">
                                   <input value={props.county} type="text" onChange={(e) => props.handelData('county', e.target.value)} className="form-control" placeholder="County" />
                            </div>
                        </div>
                        <div className="form-error-msg">{props.setcounty_validate}</div>
                    </div>
                */}

                     <div className="form-group">
                        <label>Do you have a right to work in the UK</label>
                        <select value={props.right_to_work} id="inputapply" onChange={(e) => props.handelData('right_to_work', e.target.value)} className="form-control">
                            <option >Right To Work</option>
                             {props.right_to_work_type.map((right_to_work_type, index) => (
                                <option value={right_to_work_type.id}>{right_to_work_type.type}</option>
                            ))}
                        </select>
                        <div className="form-error-msg">{props.right_to_work_validate}</div>
                    </div>
                    <div className="form-group">
                    <label>Upload CV<sup>*</sup></label>
                            <div className="custom-file">
                                <input type="file" onChange={(e) => props.handelData('upload_cv', e.target.files[0])} className="custom-file-input" id="inputGroupFile01" />
                                <label className="custom-file-label" htmlFor="inputGroupFile01">ATTACH YOUR DOCUMENT</label>
                            </div>
                            <div className="form-error-msg">{props.setuploadcv_validate}</div>
                        </div>
                    <div className="form-group">
                        <label>Upload Profile Image<sup>*</sup></label>
                            <div className="custom-file">
                                <input type="file" onChange={(e) => props.handelData('upload_image', e.target.files[0])} accept="image/*"  className="custom-file-input" id="inputGroupFile01" />
                                <label className="custom-file-label" htmlFor="inputGroupFile01">Upload Image</label>
                            </div>
                            <div className="form-error-msg">{props.setuploadimage_validate}</div>
                        </div>

                    <div className="form-btn_group">
                        { props.edit_status ?
                        <button type="button" onClick={props.handelSummit} className="btn btn-red test">Update <i className="fa fa-angle-double-right" aria-hidden="true"></i></button>
                        :
                        <button type="button" onClick={props.handelSummit} className="btn btn-red test">Submit <i className="fa fa-angle-double-right" aria-hidden="true"></i></button>
                        }
                    </div>
                </form>
            </div>
        </div>
         <CustomModalView
            modal_show={props.modal_show}
            authResponse = {props.authResponse}
            showCustomModal= {props.showCustomModal}
            hideCustomModal={props.hideCustomModal}

            />
           </>
        )
        // }
        // else{
        //  return(
        //      <Navigate to="/login" />
        //      )
        // }

}

export default CvPageView;